export const environments = {
    local: {
        APP_MAPP_ID: 'store-admin-local',
        APP_MAPP_AUTH_URL: 'https://dev.admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://dev.api.superapp.yum.com',
        API_BASE_URL: '/api',
    },
    dev: {
        APP_MAPP_ID: 'dev-byte-pulse',
        APP_MAPP_AUTH_URL: 'https://dev.admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://dev.api.superapp.yum.com',
        API_BASE_URL: '/api',
    },
    staging: {
        APP_MAPP_ID: 'staging-byte-pulse',
        APP_MAPP_AUTH_URL: 'https://staging.admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://staging.api.superapp.yum.com',
        API_BASE_URL: '/api',
    },
    production: {
        APP_MAPP_ID: 'prod-byte-pulse',
        APP_MAPP_AUTH_URL: 'https://admin.superapp.yum.com/mapp/authorize',
        REDEEM_TOKEN_BASE_URL: 'https://api.superapp.yum.com',
        API_BASE_URL: '/api',
    },
};
export function getEnvironmentConfig(env) {
    return environments[env];
}
